import moment from "moment";
import { put, call, takeEvery, select } from "redux-saga/effects";
import { defineMessages } from "react-intl";
import { ALERT_TYPES, showAlert } from "../alert/alertActions";
import * as AssignmentActions from "../assignment/assignmentActions";
import * as TaskActions from "../task/taskActions";
import { getTechnicianInfo, makeApiCall } from "../helpers";
import taskServices from "./../../services/taskServices";

const messages = defineMessages({
    assignmentSucceeded: {
        id: "alerts.assignment-sagas.assignment-succeeded",
        defaultMessage: "Assignment succeeded",
        description: "Assignment succeeded alert message",
    },
    assignmentFailed: {
        id: "alerts.assignment-sagas.assignment-failed",
        defaultMessage: "Assignment failed: {responseError}",
        description: "Assignment failed alert message",
    },
    // taskActionSucceeded: {
    //     id: 'alerts.task-sagas.task-action-succeeded',
    //     defaultMessage: '{actionDesc} succeeded',
    //     description: 'Task action succeeded alert message',
    // },
    // taskUnassign: {
    //     id: 'alerts.task-sagas.task-unassign',
    //     defaultMessage: 'Unassign',
    //     description: 'WO status unassign',
    // },
});

export const watchAssignmentRequests = function* () {
    yield takeEvery(AssignmentActions.REQUEST_ASSIGN_TASK, assignTaskAsync);
};

export const assignTaskAsync = function* (action) {
    try {
        // Push edits to server
        const technicianInfo = yield select(getTechnicianInfo);
        const overlaps = yield call(
            makeApiCall,
            taskServices.assignTask,
            {
                ...action.assignTaskRequest.assignment,
                //taskAssignedDate: moment(action.assignTaskRequest.assignment.taskAssignedDate).format("YYYY-MM-DD HH:mm:00"),
                scheduledDate: moment(action.assignTaskRequest.assignment.scheduledDate).format("YYYY-MM-DD HH:mm:00"),
                overrideWarning: action.assignTaskRequest.overrideWarning,
            },
            technicianInfo.userName,
        );

        // check for overlaps
        if (overlaps.length === 0) {
            // Add the assignment to our list of assignments
            // so we can see it in the Gantt.  Also updates the
            // Assigned totals
            yield put(AssignmentActions.updateAssignment(action.assignTaskRequest.assignment));

            // update the task in the task list
            const { technician } = action.assignTaskRequest.technician;

            // Make sure we clear any existing overlaps
            yield put(AssignmentActions.clearAssignmentOverlaps());

            // reload the updated task
            const workOrderNumber = action.assignTaskRequest.assignment.workOrderNumber;
            yield put(TaskActions.requestTaskReload(workOrderNumber, true));

            // Show UI alert to the user so he know that the assignment was
            // created successfully
            // if (action?.assignTaskRequest?.isUnassigned) {
            //     yield put(showAlert(Date.now(), messages.taskActionSucceeded, ALERT_TYPES.success, { actionDesc: messages.taskUnassign }, true));
            //   } else {
            yield put(showAlert(Date.now(), messages.assignmentSucceeded, ALERT_TYPES.success));
            //  }
        } else {
            // There are overlaps so the user must acknowledge the overlaps
            yield put(AssignmentActions.showAssignmentOverlaps(overlaps));
        }
    } catch (responseError) {
        // const date = yield (new Date()).getTime();
        yield put(showAlert(Date.now(), messages.assignmentFailed, ALERT_TYPES.error, { responseError: responseError.toString() }, true));
    }
};
